import { render } from "./App.vue?vue&type=template&id=0a3f4c12"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0a3f4c12&lang=scss"

import exportComponent from "C:\\Users\\guada\\OneDrive\\Documents\\GitHub\\simulador-tweets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__